import previewModal from './previewModal.vue';
import { downloadFileFun } from '@/utils/public';
import { getBase64, isImage, isVideo, isPDF } from './utils';
import { streamInfo } from '@/views/organization/staffManage/request';
export default {
  components: {
    previewModal
  },
  props: ['previewVisible', 'fileList', 'download'],
  data() {
    return {
      currentPreviewIndex: 0,
      previewSrc: '',
      previewPDF: '',
      isShow: '',
      isPDFShow: false,
      previewVisible2: false
    };
  },
  methods: {
    // 预览处理
    async handlePreview(file) {
      this.isShow = '';
      if (isImage(file.name)) {
        this.isShow = 'image';
      }
      if (isVideo(file.name)) {
        this.isShow = 'video';
      }
      this.isPDFShow = isPDF(file.name);
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj);
      }
      if (this.isShow === 'image' || this.isShow === 'video') {
        this.previewSrc = file.url || file.preview;
        this.currentPreviewIndex = this.fileList.indexOf(file);
      } else if (this.isPDFShow) {
        this.previewPDF = file.url || file.response.data.fileTempUrl;
        window.open(this.previewPDF);
        return;
      } else {
        window.open(file.url || file.response.data.fileTempUrl);
        return;
      }
      this.previewVisible2 = true;
    },
    handleDownload(obj) {
      const type2 = obj.format == 'pdf' ? 'application/pdf' : obj.format == 'png' ? 'image/png' : obj.format == 'jpg' ? 'image/jpg' : obj.format == 'jpeg' ? 'image/jpeg' : obj.format == 'gif' ? 'image/gif' : obj.format == 'jfif' ? 'image/jfif' : '';
      streamInfo({
        url: obj.url
      }).then(res => {
        console.log(res);
        downloadFileFun(res, type2, obj.name);
      });
    }
  }
};